;(function(exports){
	var KeyBoard = function(input, options,vm){
		var body = document.getElementsByTagName('body')[0];
		var DIV_ID = options && options.divId || 'keyBoardPopups';

		if(document.getElementById(DIV_ID)){
			body.removeChild(document.getElementById(DIV_ID));
		}

		this.input = input;
		this.el = document.createElement('div');

		var self = this;
		var zIndex = options && options.zIndex || 1000;
		var width = options && options.width || '100%';
		var height = options && options.height || '225px';
		var fontSize = options && options.fontSize || '15px';
		var backgroundColor = options && options.backgroundColor || '#f5f5f5';
		var TABLE_ID = options && options.table_id || 'table_0909099';
		var mobile = typeof orientation !== 'undefined';

		this.el.id = DIV_ID;
		this.el.style.position = 'fixed';
		this.el.style.left = 0;
		this.el.style.right = 0;
		this.el.style.bottom = '40px';
		this.el.style.zIndex = zIndex;
		this.el.style.width = width;
		this.el.style.height = height;
    this.el.style.backgroundColor = backgroundColor;
    this.el.style.backgroundColor = backgroundColor;

		//样式
		var cssStr = '<style type="text/css">';
		cssStr += '#' + TABLE_ID + '{text-align:center;width:100%;height: 225px;border-top:1px solid #d6d6d6;background-color:#f5f5f5;font-size: 24px;}';
		cssStr += '#' + TABLE_ID + ' td{width:25%;border:1px solid #d6d6d6;border-right:0;border-top:0;height: 55px; color: #282828;}.back-del{background: url("../../static/images/delete.svg") no-repeat center;background-size: 20%;}.keyboard-but:hover{background:#c23a3a;}';
		//手机样式
		//if(!mobile){
			cssStr += '#' + TABLE_ID + ' td:active{background-color:#e0e0e0;color:#000;}';
		//}
		cssStr += '</style>';

		//Button
		var btnStr = '<div class="keyboard-but" style="position: absolute;bottom: 0;right: 0;width:25%;height:112px;line-height: 112px;background-color:#e2231a;';
		btnStr += 'text-align:center;color:#fff;font-size: 16px;';
		btnStr += 'cursor:pointer;" >支付</div><p style="position: absolute;bottom: -40px;right: 0;width:100%;height: 40px;line-height: 40px; font-size: 11px;color: #dcdcdc;text-align: center;">在街上收银</p><div  style="position: absolute;top: -25px;left: 0;width: 100%; height:25px; text-align:center; background: #f5f5f5; border-top: 1px solid #d6d6d6;"><img style="display:block; width: 19px; margin: 7px auto 0;" src="../../static/images/down.png"/></div>';

		//table
		var tableStr = '<table id="' + TABLE_ID + '" border="0" cellspacing="0" cellpadding="0">';
			tableStr += '<tr><td>1</td><td>2</td><td>3</td><td rowspan="2" class="back-del"><span style="display: none;">删除</span></td></tr>';
			tableStr += '<tr><td>4</td><td>5</td><td>6</td></tr>';
			tableStr += '<tr><td>7</td><td>8</td><td>9</td><td rowspan="2">&nbsp;</td></tr>';
			tableStr += '<tr><td colspan="2">0</td><td>.</td></tr>';
			tableStr += '</table>';
		this.el.innerHTML = cssStr + btnStr + tableStr;

		function addEvent(e){
			var ev = e || window.event;
			var clickEl = ev.element || ev.target;
			var value = clickEl.textContent || clickEl.innerText;
			var rex=/^\d{1,5}(|(\.\d{0,2}))$/; //小数点前5位小数点后两位
			if(clickEl.tagName.toLocaleLowerCase() === 'td' && value !== "删除"){
				var num = self.input.value?self.input.value:self.input.innerText+value; //验证value、innerText，获取值,加入点击的值
				if(rex.test(num)){
				console.log(rex.test(num)+"*"+num);
				self.input.value?self.input.value=num:self.input.innerText=num;//验证value、innerText，加值
				vm.inputFee = num;
				}

			}else if(clickEl.tagName.toLocaleLowerCase() === 'td' && value === "删除"){
				var num = self.input.value?self.input.value:self.input.innerText;//验证value、innerText，获取值
				if(num){
					var newNum = num.substr(0, num.length - 1);
					self.input.value?self.input.value=newNum:self.input.innerText=newNum;//验证value、innerText，减值
					vm.inputFee = newNum;
				}
			}
			else if(clickEl.tagName.toLocaleLowerCase() === 'div' && value === "支付"){
        var ua = navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == "micromessenger") {
					//微信浏览器
					vm.wxpay();

				} else if(ua.match(/alipay/i) == "alipay") {
					vm.pay();
				}
				 setTimeout(function(){
				 	document.getElementById('keyBoardPopups').remove();
				 },200)
				 //vm.ticket();
			}
			else if(clickEl.tagName.toLocaleLowerCase() === 'div' || clickEl.tagName.toLocaleLowerCase() === 'img' && value !== "支付"){
				 setTimeout(function(){
				 	document.getElementById('keyBoardPopups').remove();
				 },200)
				 //document.getElementById('keyBoardPopups').remove();
			}
		}

		if(mobile){
			this.el.ontouchstart = addEvent;
		}else{
			this.el.onclick = addEvent;
		}
		document.getElementById("qcode").appendChild(this.el);
	}

	exports.KeyBoard = KeyBoard;


})(window);
//数字键盘完成按钮点击事件




//////////////////
// WEBPACK FOOTER
// ./static/js/keyboard.js
// module id = b18W
// module chunks = 53